import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GenesysCloudService } from './genesys-cloud.service';
import { UsuarioService } from './usuario.service';
import { GenesysCloudWebrtcSdk } from 'genesys-cloud-webrtc-sdk';
import { GeneralServicesService } from './general-services.service';
import { LambdaServicesService } from './lambda-services.service';
import { formatDate } from '@angular/common';
import { environment } from '../../environments/environment';


@Injectable({
	providedIn: 'root'
})
export class SocketGenesysService {
	private URL_SERVICIOS_GENESYS = environment.URL_SERVICIOS_GENESYS;

	genesys_socket: WebSocket;
	usuario: any = {};
	token_data: any = {};
	public conversationStatus: any = {
		connectedStatus: "connected",
		disconnectedStatus: "disconnected",
		terminatedStatus: "terminated",
		alertingStatus: "alerting",
		dialingStatus: "dialing",
		contactingStatus: "contacting",
	};

	public currentCampaign: any = {};
	public conversations: any = [];
	public arrayConversations: any = [];

	public isWSActive: any;
	public webRtcSdk: GenesysCloudWebrtcSdk;
	public webRtcSession: any;

	public wrapup_code_selected: any = '';
	public call_complete: any = false;


	public topicPresence: any;
	public topicRoutingStatus: any;
	public topicConversations: string = '';
	public topicAssistant: string = '';
	// public topicQueues: string = '';
	private urlSubscriptions = '';
	public currentPresence: any = { languageLabels: {} };
	public currentRoutingStatus: any = {};

	public callBackPreference: any = '';
	public callBackList: any = [];

	public phoneSelected: any = '';

	public ringtone: any = new Audio('assets/tonos/tono-llamada-nextel.mp3');

	public editDataDetails: any = [];
	public subject = new Subject<any>();
	private messageSource = new BehaviorSubject(this.editDataDetails);
	currentMessage = this.messageSource.asObservable();

	public id_cc_rellamada = "be97b3c8-ffd6-4382-91bd-7a230d662b61"; //Este id no debe aparecer en la lista de c. de conclusión
	public lenConversations = this.conversations.length;

	constructor(
		private genesys_services: GenesysCloudService,
		public usuario_services: UsuarioService,
		private general_services: GeneralServicesService,
		private lambda_services: LambdaServicesService
	) {
		//console.log(this.ringtone, 'Audio');
	}

	createSocket(data) {
		console.log('Creacion de socket')
		this.usuario = this.usuario_services.obtenerUsuarioStorage();
		this.token_data = this.usuario_services.obtenerTokenStorage();
		console.log('Previo a suscribeToConversation')
		this.resetCallBackPreference();
		this.subscribeToConversations(data);

	}

	subscribeToConversations(data: any) {
		this.topicConversations = "v2.users." + this.usuario.id + ".conversations";
		this.topicPresence = "v2.users." + this.usuario.id + ".presence";
		this.topicRoutingStatus = "v2.users." + this.usuario.id + ".routingStatus";
		// this.topicAssistant = "v2.users." + this.usuario.id + ".transcription";

		this.urlSubscriptions = "https://api.mypurecloud.com/api/v2/notifications/channels/" + data.id + "/subscriptions";
		let topics = [
			{ "id": this.topicConversations },
			{ "id": this.topicPresence },
			{ "id": this.topicRoutingStatus },
			// { "id": this.topicAssistant }
		];
		this.genesys_socket = new WebSocket(data.connectUri); //dummy echo websocket service
		this.webRtcSdk = new GenesysCloudWebrtcSdk({ accessToken: this.token_data.token });
		this.genesys_socket.onopen = (evt) => {
			this.genesys_services.makeSubscriptionSocket(this.urlSubscriptions, topics);
			this.getActiveInteractions();
			this.isWSActive = true;
			// this.checkHealthWS();
		};

		this.genesys_socket.onclose = (evt) => {
			setTimeout(function () {
				this.subscribeToConversations();
			}, 1000);
		};

		this.genesys_socket.onerror = (evt) => {
			this.genesys_socket.close();
			//console.log("webSocket.onerror", JSON.stringify(evt), "error");
		};
	}

	configWebRTC() {
		// Optionally set up some SDK event listeners (not an exhaustive list)
		this.webRtcSdk.on('sdkError', (e) => {
			//console.log("webRtcSdk.sdkError");/* do stuff with the error */
			this.general_services.modalErrorMensaje("Error al cargar audio", "Recargue la página, puede que tenga problemas de internet.");
		});
		this.webRtcSdk.on('pendingSession', (e) => {
			console.log(e, "webRtcSdk.pendingSession");
			this.webRtcSession = e;
			/* pending session incoming */
		}); this.webRtcSdk.on('sessionStarted', (e) => { console.log("webRtcSdk.sessionStarted");/* a session just started */ });
		this.webRtcSdk.on('handledPendingSession', (e) => { console.log("webRtcSdk.handledPendingSession"); });
		this.webRtcSdk.on('cancelPendingSession', (e) => { console.log("webRtcSdk.cancelPendingSession"); });
		this.webRtcSdk.on('connected', (e) => { console.log("webRtcSdk.connected"); });
		this.webRtcSdk.on('disconnected', (e) => { console.log("webRtcSdk.disconnected"); });
		this.webRtcSdk.on('trace', (e) => { console.log("webRtcSdk.trace"); });

		this.webRtcSdk.initialize().then(() => {
			// the web socket has connected and the SDK is ready to use
			//console.log("webRtcSdk.initialize");
		});
	}


	newMessageReceived(): Observable<any> {
		return new Observable(observer => {
			this.genesys_socket.onmessage = (evt) => {
				observer.next(evt);
			};
		});
	}

	joinRoom(data) {
		this.genesys_socket = new WebSocket(data.connectUri);

		let url = "https://api.mypurecloud.com/api/v2/notifications/channels/" + data.id + "/subscriptions";
		this.genesys_socket.addEventListener('open', function (event) {
			//console.log(event);
		});

		this.genesys_services.makeSubscriptionSocket(url, this.topicConversations)
			.then(result => {
				this.isWSActive = true;
			})
			.catch(error => {
				console.log(error);
			});

		// Escucha por mensajes
		this.genesys_socket.addEventListener('message', function (event) {
			//console.log('Message from server', event.data);

		});

		this.genesys_socket.onmessage = function (event) {


		};

	}


	evalConversation(conversationId, agentParticipant, conversation, mediaType, queueId, agentData, customerData, ivrParticipant) {
		let connectedStatus = (conversation.state.toLowerCase() == this.conversationStatus.connectedStatus) ? true : false;
		let disconnectedStatus = (conversation.state.toLowerCase() == this.conversationStatus.disconnectedStatus) ? true : false;
		let terminatedStatus = (conversation.state.toLowerCase() == this.conversationStatus.terminatedStatus) ? true : false;
		let alertingStatus = (conversation.state.toLowerCase() == this.conversationStatus.alertingStatus) ? true : false;
		let dialingStatus = (conversation.state.toLowerCase() == this.conversationStatus.dialingStatus) ? true : false;
		let contactingStatus = (conversation.state.toLowerCase() == this.conversationStatus.contactingStatus) ? true : false;
		let indexConversation = this.indexArrayConversations(conversationId);
		let actualConversation = this.searchArrayConversations(conversationId, alertingStatus);

		//console.log(indexConversation, "indexConversation-evalConversation")
		//console.log(conversationId, "conversationId-evalConversation")
		//console.log(agentParticipant, "agentParticipant-evalConversation")
		//console.log(conversation, "conversation-evalConversation")
		//console.log(mediaType, "mediaType-evalConversation")
		//console.log(queueId, "queueId-evalConversation")
		//console.log(agentData, "agentData-evalConversation")
		//console.log(customerData, "customerData-evalConversation")
		//console.log(actualConversation, "actualConversation-evalConversation")
		//console.log(ivrParticipant, "ivrParticipant-evalConversation")

		if ((disconnectedStatus || terminatedStatus) && (agentParticipant.wrapup && agentParticipant.wrapup.code)) {
			this.clearConversation(conversationId);
			return;
		} else if ((terminatedStatus) && agentParticipant.wrapupRequired && !agentParticipant.wrapup && mediaType == 'call-outbound') {
			this.setWrapupCode(conversationId, agentParticipant.id, mediaType, conversation.id, this.id_cc_rellamada);
			return;
		}

		if (indexConversation == -1 && !actualConversation.isNew) {
			return;
		} else if (indexConversation == -1 && actualConversation.isNew) {
			indexConversation = this.conversations.push(this.newConversation(conversationId));

			// this.callAssistant(queueId, conversationId);

			indexConversation = indexConversation - 1;
		}

		if (this.conversations[indexConversation].state.toLowerCase() == this.conversationStatus.alertingStatus && (disconnectedStatus || terminatedStatus)) {
			this.clearConversation(conversationId);
			return;
		}

		try {
			if ((!this.conversations[indexConversation].customer.attributes.flujo && customerData.attributes.flujo) || (this.conversations[indexConversation].customer.attributes.flujo && customerData.attributes.flujo && this.conversations[indexConversation].customer.attributes.flujo != customerData.attributes.flujo)) {
				if (customerData.attributes.flujo == "exito") {
					this.general_services.modalMensaje({ titulo: "IVR Exitoso", mensaje: "Proceso de IVR exitoso." });
				} else if (customerData.attributes.flujo == "no_exito") {
					this.general_services.modalErrorMensaje("IVR NO Exitoso", "Proceso de IVR NO exitoso.");
				}
			}
		} catch (error) {
		}

		//Si proviene de una llamada outbound
		if (!this.conversations[indexConversation].currentContact.data && customerData && customerData.contactListId && customerData.id) {

			this.getDataCustomer(customerData.contactListId, customerData.id, indexConversation, queueId);
			this.getConversationWrapupCodes(conversationId, agentData.participantId, indexConversation);
			//Si es una rellamada	
		} else if (!this.conversations[indexConversation].currentContact.data && this.conversations.length > 1) {

			this.conversations[indexConversation].currentContact = this.conversations[0].currentContact;
			this.conversations[indexConversation].phoneList = this.conversations[0].phoneList;
			this.conversations[indexConversation].currentCampaignLambda = this.conversations[0].currentCampaignLambda;
			this.conversations[indexConversation].wrapupCodes = this.conversations[0].wrapupCodes;
			//Si proviene de una llamada inbound pero trae un contacto en la metadata
		} else if (!this.conversations[indexConversation].currentContact.data
			&& customerData
			&& customerData.attributes
			&& !customerData.contactListId
			&& !customerData.campaignId) {

			this.getDataCustomerInbound(conversationId, queueId, customerData.attributes, indexConversation);
			this.getConversationWrapupCodes(conversationId, agentData.participantId, indexConversation);
			//Si proviene de una llamada inbound
		} else if (!this.conversations[indexConversation].currentContact.data && customerData && !customerData.contactListId && !customerData.campaignId) {

			this.getInfoRecall(indexConversation, queueId, conversationId);
			this.getConversationWrapupCodes(conversationId, agentData.participantId, indexConversation);

		}

		if (agentParticipant.calls) {
			this.conversations[indexConversation].held = agentParticipant.calls[0].held;
			this.conversations[indexConversation].muted = agentParticipant.calls[0].muted;
		} else {
			this.conversations[indexConversation].held = false;
			this.conversations[indexConversation].muted = false;
		}

		this.conversations[indexConversation].customer = customerData;
		this.conversations[indexConversation].mediaType = mediaType;
		this.conversations[indexConversation].communicationId = conversation.id;
		this.conversations[indexConversation].wrapupRequired = agentParticipant.wrapupRequired;
		this.conversations[indexConversation].queueId = queueId;
		this.conversations[indexConversation].agent = agentData;
		this.conversations[indexConversation].contactListId = customerData.contactListId;
		console.log(this.conversations[0].mediaType)
		this.conversations[indexConversation].conversation = conversation;
		if (this.conversations[0] && this.conversations[0].mediaType && (this.conversations[0].mediaType == 'call-inbound' || this.conversations[0].mediaType == 'callback') && customerData && customerData.phone) {
			let phoneList = [this.conversations[0].customer.phone];
			this.conversations[0].phoneList = phoneList;
		}
		//Si no existe el id de campana y tambien viene en el cliente
		if (!this.conversations[indexConversation].campaignId && customerData.campaignId) {
			this.conversations[indexConversation].campaignId = customerData.campaignId;
		} else if (!this.conversations[indexConversation].campaignId && this.conversations[indexConversation].currentCampaignLambda && this.conversations[indexConversation].currentCampaignLambda.url_genesys_campaing_id) {
			this.conversations[indexConversation].campaignId = this.conversations[indexConversation].currentCampaignLambda.url_genesys_campaing_id;
		}
		this.conversations[indexConversation].callback = actualConversation.callback;
		if (agentParticipant) {
			this.conversations[indexConversation].agentParticipant = agentParticipant;
		}
		this.conversations[indexConversation].ivrParticipant = ivrParticipant;
		this.conversations[indexConversation].state = conversation.state.toLowerCase();


		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

		if ((alertingStatus) && (mediaType == "dialer" || mediaType == "dialer-preview" || mediaType == "callback") && actualConversation.isNew) {
			try {
				this.ringtone.play();
			} catch (error) {
				console.log(error, 'error-play');
			}
			this.phoneSelected = '';
		}
		this.modifyPhoneNumber(indexConversation);
		console.log(this.conversations, 'conversations-evalConversation');
	}

	clearConversation(idConversation) {
		try {
			let indexConversation = this.indexArrayConversations(idConversation);
			if (indexConversation != -1) {
				this.conversations.splice(indexConversation, 1);
			}
		} catch (e) {
			console.log(e, 'e-clearConversation');
		}
	}

	// async callAssistant(queueId, conversationId) {
	// 	try {
	// 		let resAssistant = await this.genesys_services.getAssistant(queueId);
	// 		console.log('assitant - ', resAssistant);
	// 		if (resAssistant && resAssistant.assistant && resAssistant.assistant.id) {
	// 			let newTopics = [
	// 				{ "id": "v2.conversations." + conversationId + ".transcription" },
	// 				{ "id": "v2.conversations." + resAssistant.assistant.id + ".suggestions.script" },
	// 			];
	// 			this.genesys_services.makeSubscriptionSocket(this.urlSubscriptions, newTopics);
	// 		}
	// 	} catch (error) {
	// 		console.log('assitant - error ', error);

	// 	}
	// }

	searchArrayConversations(idConversation, alertingStatus) {

		let indexArray = this.serchInArrayConversations(idConversation);
		let element = {
			id_interaccion: idConversation,
			callback: false,
			isNew: true
		};

		if (indexArray == -1) {
			this.arrayConversations.push(element);
			//console.log(element, 'element-searchArrayConversations');
			return element;
		} else {
			this.arrayConversations[indexArray].isNew = alertingStatus ? true : false;
			//console.log(this.arrayConversations[indexArray], 'arrayConversations[indexArray]-searchArrayConversations');
			let oldConversation = this.arrayConversations[indexArray];
			return oldConversation;
		}
	}

	serchInArrayConversations(idConversation) {
		for (let index = this.arrayConversations.length - 1; index >= 0; index--) {
			const element = this.arrayConversations[index];
			if (element.id_interaccion == idConversation) {
				return index;
			}
		}
		return -1;
	}

	indexArrayConversations(idConversation) {
		for (let index = this.conversations.length - 1; index >= 0; index--) {
			const element = this.conversations[index];
			if (element.id && element.id == idConversation) {
				return index;
			}
		}
		return -1;
	}

	resetConversation() {
		this.conversations = [];
	}

	newConversation(newIdConversation) {
		return {
			id: newIdConversation,
			state: "",
			mediaType: "",
			communicationId: "",
			callback: false,
			wrapupRequired: null,
			held: null,
			campaignId: "",
			contactListId: "",
			callbackArray: [],
			wrapupCodes: [],
			currentContact: {},
			currentCampaignLambda: {},
			phoneList: [],
			formComplete: false,
			saleFormComplete: false,
			customer: {
				name: '',
				phone: '',
				id: '',
				campaignId: '',
				contactListId: '',
				attributes: {}
			},
			queueId: "",
			agent: {
				participantId: ''
			},
			callActive: false,
			actualConversation: {
				id_interaccion: '',
				callback: false,
				conclutionCode: false,
			},
			agentParticipant: {},
			ivrParticipant: null
		};
	}


	async getConversationWrapupCodes(conversationId, agentParticipantId, indexConversation) {
		//console.log(conversationId, agentParticipantId, "conversationId-agentParticipantId");
		let url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + agentParticipantId + "/wrapupcodes?nocache=" + Math.random();
		await this.genesys_services.getConversationWrapupCodes(url)
			.then(result => {
				//console.log(result, 'result-getConversationWrapupCodes');

				this.conversations[indexConversation].wrapupCodes = result;
			})
			.catch(error => {
				console.log(error);
			})
	}

	getTimezone() {
		if (this.currentCampaign && this.currentCampaign.url_timezone) {
			return this.currentCampaign.url_timezone;
		}
		return "-03:00";
	}

	async generateCallback(fecha, skillsArray, callbackMessage) {

		let date = fecha ? fecha : new Date();
		let dateString = formatDate(date, 'dd/MM/yyyy HH:mm:ss', 'en-US', this.getTimezone().replaceAll(':', ''));
		let tipo = fecha ? 'Agendamiento' : 'Rellamar';
		console.log(this.getTimezone().replaceAll(':', ''));
		console.log(date.toISOString(), "date-generateCallback");
		console.log(dateString, "dateString-generateCallback");

		let data: any = {
			dialerContactId: this.conversations[0].currentContact.id ?? '',
			dialerCampaignId: this.conversations[0].currentCampaignLambda.url_genesys_campaing_id ?? '',
			dialerContactListId: this.conversations[0].currentContact.contactListId ?? '',
			sourceConverstionId: this.conversations[0].id ?? '',
			callbackMessage: callbackMessage,
			dateString: dateString,
			tipo: tipo,
			observacion: callbackMessage,
			resultCallback: null,
			skillsArray: null,
			userId: this.usuario.id,
			skillId: skillsArray && skillsArray.length > 0 ? skillsArray[0] : null,
			newConversationId: null,
			rut: this.conversations[0].currentContact && this.conversations[0].currentContact.data && this.conversations[0].currentContact.data.rut ? this.conversations[0].currentContact.data.rut.substring(0, 4) : '',
			name: this.conversations[0].currentContact && this.conversations[0].currentContact.data && this.conversations[0].currentContact.data.nombre ? this.conversations[0].currentContact.data.nombre : '',
		};
		return await this.genesys_services.createCallback(this.conversations[0].customer.name ?? 'customer', date.toISOString(), [this.conversations[0].customer.phone], this.conversations[0].queueId, data, skillsArray)
			.then((result: any) => {
				if (fecha) {
					this.updateArrayConversationsCallback(this.conversations[0].id);
				}
				data.resultCallback = result;
				data.skillsArray = skillsArray;
				//console.log(result, 'result-createCallback');
				data.newConversationId = result.conversation.id;
				//console.log(data, 'data-createCallback');
				this.lambda_services.postCallback(this.conversations[0].id, data, this.conversations[0].currentContact.data.con_id);
				this.genesys_services.updateContactOfContactList(this.conversations[0].currentContact.contactListId, this.conversations[0].currentContact.id, this.conversations[0].currentContact.data);
				return result;
			})
			.catch(error => {
				console.log(error, 'error-generateCallback');
				throw error;
			})
	}


	async generateCall() {

		if (!this.phoneSelected || this.phoneSelected == '') {
			this.general_services.modalErrorMensaje('Error', 'Por favor seleccione un número válido.');
			return;
		}

		let date = new Date();
		let dateString = formatDate(date, 'dd/MM/yyyy HH:mm:ss', 'en-US');
		let tipo = 'Rellamar';
		return await this.genesys_services.createCall(this.phoneSelected, this.conversations[0].queueId, this.conversations[0].id)

			.then((result: any) => {
				let data_tipificacion = {
					id_gestion: result.id,
					id_gestion_padre: this.conversations[0].id,
					id_contacto: (this.conversations[0].currentContact.id) ? this.conversations[0].currentContact.data.con_id : this.conversations[0].id,
					id_campana: this.conversations[0].currentCampaignLambda.url_genesys_campaing_id,
					id_contacto_genesys: (this.conversations[0].currentContact.id) ? this.conversations[0].currentContact.id : this.conversations[0].id,
					fono: this.phoneSelected,
					cola: this.conversations[0].queueId,
					id_ejecutivo: this.conversations[0].agentParticipant.userId,
					contacto: 'RELLAMADA',
					nivel1: 'RELLAMADA',
					nivel2: 'RELLAMADA',
					nivel3: 'RELLAMADA',
				}
				//console.log(data_tipificacion, 'data_tipificacion-createCall');
				this.lambda_services.handleEnvioTipificaciones(data_tipificacion);
				return result;
			})
			.catch(error => {
				console.log(error, 'error-generateCall');
				throw error;
			})
	}

	updateArrayConversationsCallback(id_interaccion) {
		let index = this.indexArrayConversations(id_interaccion);
		if (index == -1) {
			return;
		}
		this.conversations[index].callback = true;
	}

	checkHealthWS() {
		if (this.genesys_socket) {
			if (this.isWSActive) {
				this.isWSActive = false;
				//console.log(this.isWSActive);
				//Revisa la conexion del this.genesys_socket cada minuto
				setTimeout(function () {
					this.checkHealthWS();
				}, 60000);
			}
			else {
				this.genesys_socket.close();
			}
		}
	};

	async endCall(conversations: any) {
		await this.disconnectCall(conversations.id, conversations.agent.participantId, conversations.mediaType, conversations.communicationId);
	}

	answerCall(conversation) {
		//console.log(conversation, "conversation - answerCall");

		//console.log(this.webRtcSession);
		//console.log(conversation);

		try {
			if (this.webRtcSession && !this.webRtcSession.autoAnswer) {
				//console.log(this.webRtcSession.id, 'this.webRtcSession.id');
				this.webRtcSdk.acceptPendingSession(this.webRtcSession.id);
			}

			if (conversation.state.toLowerCase() == this.conversationStatus.alertingStatus && (conversation.mediaType == "dialer-preview" || conversation.mediaType == "callback")) {
				this.genesys_services.answerCall(conversation.id, conversation.agent.participantId, "callbacks");
			}
			else {
				this.genesys_services.answerCall(conversation.id, conversation.agent.participantId, "calls");
			}
		} catch (e) {
			console.log(e, 'answerCall-ERROR');
			//console.log('Se hace skip a registro por error al contestar llamada');
			this.skip(conversation);
		}
	}

	async skip(conversation) {
		await this.patchConversation(conversation.id, conversation.agent.participantId, { "wrapup": { "code": "ININ-OUTBOUND-PREVIEW-SKIPPED", "notes": "", "tags": [] } });
		await this.endCall(conversation);
		this.resetConversation();
	}

	async consult(conversationId, customerParticipantId, _data) {
		await this.genesys_services.consultTransfer(conversationId, customerParticipantId, _data);
	}

	cancelConsultTransfer() {
		this.genesys_services.cancelConsultTransfer(this.conversations[0].id, this.conversations[0].customer.participantId);
	}

	makeCallPreview(conversation: any) {
		//console.log(conversation, "makeCallPreview-conversations");

		//console.log(this.conversations[0].currentContact, "makeCallPreview-currentContact");
		if (!this.phoneSelected || this.phoneSelected == '') {
			this.general_services.modalErrorMensaje('Error', 'Por favor seleccione un número válido.');
			return;
		}

		this.genesys_services.makeCallPreview(conversation.id, this.phoneSelected)
			.then(result => {
				conversation.callActive = true;
			});
	}

	async wrapup() {
		const wrapupCodeId = this.wrapup_code_selected;
		await this.setWrapupCode(
			this.conversations[0].id,
			this.conversations[0].agent.participantId,
			this.conversations[0].mediaType,
			this.conversations[0].communicationId,
			wrapupCodeId);
	}

	async createSecureIVR(disconnect, conversation) {//La variable disconnect puede ser false o true
		let indexConversation = this.indexArrayConversations(conversation.id);

		//console.log(this.conversations[indexConversation].currentCampaignLambda, 'conversations[indexConversation].currentCampaignLambda-createSecureIVR');
		//console.log(this.conversations[indexConversation].currentCampaignLambda.url_metadata, 'conversations[indexConversation].currentCampaignLambda.url_metadata-createSecureIVR');
		if (!this.conversations[indexConversation].currentCampaignLambda.url_metadata || !this.conversations[indexConversation].currentCampaignLambda.url_metadata.ivrFlowId || this.conversations[indexConversation].currentCampaignLambda.url_metadata.ivrFlowId == '') {
			this.general_services.modalErrorMensaje('Error', 'Error al generar canal de IVR, contactar a TI.');
			return;
		}
		let userData = "Prueba Flujo";

		let params = {
			"attributes": {
				"flujo": "Se manda a IVR"
			}
		};

		try {
			await this.genesys_services.setParticipantAtribute(conversation.id, conversation.customer.participantId, JSON.stringify(params));
		} catch (error) {
			console.log(error, 'error-setParticipantAtribute');
		}

		await this.genesys_services.createSecureIVR(this.conversations[indexConversation].id, this.conversations[indexConversation].customer.participantId, this.conversations[indexConversation].currentCampaignLambda.url_metadata.ivrFlowId, userData, disconnect)
			.then(result => {
				this.general_services.modalMensaje({ titulo: 'Exito IVR', mensaje: 'Exito al generar IVR, espere a que el cliente se reincorpore a la llamada.', time: 15000 });
			})
			.catch(error => {
				this.general_services.modalErrorMensaje('Error al generar IVR', 'Error al generar IVR, contactar a TI');
				console.log(error, 'error-createSecureIVR');
			})
	}

	async disconnectCall(conversationId, agentParticipantId, mediaType, communicationId) {

		//console.log("disconnectCall", conversationId, agentParticipantId, mediaType, communicationId);

		let url;

		if (mediaType == "dialer-preview") {
			url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + agentParticipantId + "/communications/" + communicationId;

			await this.genesys_services.disconnectCall(url, JSON.stringify({ "state": "DISCONNECTED" }))
				.then(async result => {
					//console.log(result);
					url = this.URL_SERVICIOS_GENESYS + "/conversations/callbacks/" + conversationId + "/participants/" + agentParticipantId;
					await this.genesys_services.disconnectCallback(url, JSON.stringify({ "state": "DISCONNECTED" }))
						.then(result2 => {
							//console.log(result2);
						})
						.catch(error => {
							console.log(error);
							this.general_services.modalErrorMensaje('Llamada', 'Error inesperado, contactar a Soporte.');
						})
				})
				.catch(error => {
					console.log(error);
					this.general_services.modalErrorMensaje('Llamada', 'Error inesperado, contactar a Soporte.');
				})

		}

		url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + agentParticipantId;

		await this.genesys_services.disconnectCall(url, JSON.stringify({ "state": "DISCONNECTED" }))
			.then(result => {
				// //console.log(result);
				this.general_services.modalMensaje({ titulo: 'Llamada', mensaje: 'Llamada cortada.' });

			})
			.catch(error => {
				this.general_services.modalErrorMensaje('Llamada', 'Error inesperado, contactar a Soporte.');
				console.log(error);
			})
	}

	async setWrapupCode(conversationId, agentParticipantId, mediaType, communicationId, wrapupCode) {
		let url;
		if (mediaType == "dialer-preview") {
			url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + agentParticipantId + "/communications/" + communicationId;

			await this.genesys_services.disconnectCall(url, JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] }, "state": "DISCONNECTED" }))
				.then(async result => {

					url = this.URL_SERVICIOS_GENESYS + "/conversations/callbacks/" + conversationId + "/participants/" + agentParticipantId;
					await this.genesys_services.disconnectCallback(url, JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] }, "state": "DISCONNECTED" }))
						.then(result2 => {
							//console.log(result2);
							//console.log("releaseCall.dialerPreview", "success -> url: " + url + ", mediaType: dialer-preview, conversationId: " + conversationId + ", data: " + JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] } }));
						})
						.catch(error => {
							console.log(error);
							this.general_services.modalErrorMensaje('Código de Conclusión', 'Error inesperado, contactar a Soporte.');
						})
				})
				.catch(error => {
					this.general_services.modalErrorMensaje('Código de Conclusión', 'Error inesperado, contactar a Soporte.');
					console.log(error);
				})
		}
		url = this.URL_SERVICIOS_GENESYS + "/conversations/calls/" + conversationId + "/participants/" + agentParticipantId;

		await this.genesys_services.disconnectCall(url, JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] } }))
			.then(async result => {
				url = this.URL_SERVICIOS_GENESYS + "/conversations/callbacks/" + conversationId + "/participants/" + agentParticipantId;
				await this.genesys_services.disconnectCallback(url, JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] } }))
					.then(result2 => {
						if (mediaType != 'call-outbound') {
							this.general_services.modalMensaje({ titulo: 'Código de Conclusión', mensaje: 'Código de conclusión ingresado.' });
						}
						//console.log("releaseCall", "success -> url: " + url + ", conversationId: " + conversationId + ", data: " + JSON.stringify({ "wrapup": { "code": wrapupCode, "notes": "", "tags": [] } }));
						this.wrapup_code_selected = '';
					})
					.catch(error => {
						console.log(error);
						this.general_services.modalErrorMensaje('Código de Conclusión', 'Error inesperado, contactar a Soporte.');
					})
			})
			.catch(error => {
				console.log(error);
				this.general_services.modalErrorMensaje('Código de Conclusión', 'Error inesperado, contactar a Soporte.');
			})

		try {
			if (mediaType == "callback") {
				url = this.URL_SERVICIOS_GENESYS + "/conversations/callbacks/" + conversationId + "/participants/" + agentParticipantId;

				await this.genesys_services.disconnectCall(url, JSON.stringify({ "state": "DISCONNECTED", "communicationWrapupSkipped": true }))
					.then(async result => { })
					.catch(error => {
						console.log(error);
						// this.general_services.modalErrorMensaje('Código de Conclusión', 'Error inesperado, contactar a Soporte.');
					})
			}
		} catch (error) {
			console.log(error);
		}
	}


	async patchConversation(conversationId, agentParticipantId, _data, mediaType = "calls") {
		let url = this.URL_SERVICIOS_GENESYS + "/conversations/" + mediaType + "/" + conversationId + "/participants/" + agentParticipantId;
		let data = JSON.stringify(_data);
		//console.log(data, "data-patchConversation");
		//console.log(url, "url-patchConversation");

		await this.genesys_services.patchConversation(url, data)
			.then(result => {
				//console.log(result, 'result-patchConversation');
			})
			.catch(error => {
				this.general_services.modalErrorMensaje("Error en la solicitud patchConversation", "Por favor contactar con soporte");
			})
	}


	getActiveInteractions() {
		let url = this.URL_SERVICIOS_GENESYS + "/conversations";

		this.genesys_services.getActiveInteractions(url)
			.then((result: any) => {
				if (result && result.entities && result.entities.length > 0) {
					result.entities.forEach(entity => this.setNewInteraction(entity));
					//console.log("getActiveInteractions");
					//console.log(result);

				} else {
					//console.log("getActiveInteractions", "success -> total: 0, result: " + JSON.stringify(result));
				}
			})
			.catch(error => {
				console.log(error);
				//console.log("getActiveInteractions", "error -> url: " + url + ", detail: " + JSON.stringify(error));
			})
	}


	setNewInteraction(data) {
		console.log("setNewInteraction", data);
		if (data && data.id && data.participants) {
			// //console.log(this.usuario, "usuarioAgente-setNewInteraction");

			let conversationId = data.id;
			let agentParticipant = data.participants.slice().reverse().find(p => p.userId == this.usuario.id);
			let agentParticipantConnected = data.participants.slice().reverse().find(p => p.userId == this.usuario.id && !p.endTime);
			let customerParticipant = data.participants.slice().reverse().find(p => p.purpose == "customer" || p.purpose == "external");
			let ivrParticipant = data.participants.slice().reverse().find(p => p.purpose == "ivr");
			let customerData: any = {};
			let agentData: any = {};
			let temporalConversation: any = {};
			let mediaType;
			let haveCall: boolean = (agentParticipant.calls && agentParticipant.calls.length > 0) ? true : false;
			let haveCallback: boolean = (agentParticipant.callbacks && agentParticipant.callbacks.length > 0) ? true : false;
			let haveParticipant: boolean = (customerParticipant && customerParticipant.attributes && customerParticipant.attributes.dialerContactId) ? true : false;

			if (agentParticipantConnected) {
				agentParticipant = agentParticipantConnected;
				agentData.participantId = agentParticipant.id;
				agentData.userId = agentParticipant.userId;
			} else if (agentParticipant) {
				agentData.participantId = agentParticipant.id;
				agentData.userId = agentParticipant.userId;
			} else {
				return;
			}
			//console.log(agentData, "agentData-setNewInteraction");
			//console.log(agentParticipantConnected, "agentParticipantConnected-setNewInteraction")
			//console.log(customerParticipant, "customerParticipant-setNewInteraction")
			//console.log(agentParticipant, "agentParticipant-setNewInteraction")
			//console.log(haveCall, "haveCall-setNewInteraction")
			//console.log(haveCallback, "haveCallback-setNewInteraction")
			//console.log(haveParticipant, "haveParticipant-setNewInteraction")
			//console.log(ivrParticipant, "ivrParticipant-setNewInteraction")

			if (customerParticipant) {
				customerData.participantId = customerParticipant.id;
				customerData.name = customerParticipant.name;
				if (customerParticipant.attributes) {
					customerData.attributes = customerParticipant.attributes;
				}
			}

			if (haveCall) { //voice
				temporalConversation = agentParticipant.calls[0];
			} else if (haveCallback) { //callback
				temporalConversation = agentParticipant.callbacks[0];
			}
			////////////////////////////////////////////////Se obtiene phone////////////////////////////////////////////////

			if (customerParticipant && customerParticipant.address) {//phone de customer
				customerData.phone = customerParticipant.address.replace(/\D+/g, '');
			} else if (customerParticipant//phone de customer
				&& customerParticipant.callbacks
				&& customerParticipant.callbacks.length > 0
				&& customerParticipant.callbacks[0].callbackNumbers
				&& customerParticipant.callbacks[0].callbackNumbers[0]) {
				customerData.phone = customerParticipant.callbacks[0].callbackNumbers[0].replace(/\D+/g, '');
			}
			if (customerData.phone && customerData.phone.length > 10) {
				customerData.phone = customerData.phone;
			}

			////////////////////////////////////////////////Se obtiene phone////////////////////////////////////////////////

			if (haveParticipant) {
				customerData.id = customerParticipant.attributes.dialerContactId;
				customerData.campaignId = customerParticipant.attributes.dialerCampaignId;
				customerData.contactListId = customerParticipant.attributes.dialerContactListId;
			}

			if (haveCall && haveCallback && haveParticipant) {
				mediaType = "dialer-preview";
			} else if (haveCall && haveCallback && !haveParticipant) {
				mediaType = "callback";
			} else if (haveCall && haveParticipant) {
				mediaType = "dialer";
			} else if (haveCall && !haveParticipant) {
				mediaType = "call-" + agentParticipant.calls[0].direction;
			} else if (haveCallback && haveParticipant) {
				mediaType = "dialer-preview";
			} else if (haveCallback && !haveParticipant) {
				mediaType = "callback";
			} else {
				mediaType = "";
			}

			if ((agentParticipant.calls && agentParticipant.calls.length > 0) || (agentParticipant.callbacks && agentParticipant.callbacks.length > 0)) {
				this.evalConversation(conversationId, agentParticipant, temporalConversation, mediaType, agentParticipant.queueId, agentData, customerData, ivrParticipant);
			} else {
				//console.log('Sin call ni callback');
			}
		}
	}

	modifyPhoneNumber(indexConversation) {
		//console.log('Entra a modifyPhoneNumber');

		if ((!this.conversations[indexConversation].customer.phone || this.conversations[indexConversation].customer.phone == '') && this.conversations[indexConversation].currentContact && this.conversations[indexConversation].currentContact.data && this.conversations[indexConversation].currentContact.data.telefono1) {
			//console.log('No trae numero de telefono la llamada, se le asigna el primero de la data.');
			this.conversations[indexConversation].customer.phone = this.conversations[indexConversation].currentContact.data.telefono1;
		}
	}

	loadPhoneList(customerData, indexConversation) {

		//console.log(customerData, 'customerData-loadPhoneList');

		let newPhoneList = [];
		if (customerData && customerData.data && customerData.phoneNumberStatus) {
			if (customerData.data.telefono1 && customerData.data.telefono1 != '' && customerData.phoneNumberStatus.telefono1 && customerData.phoneNumberStatus.telefono1.callable && customerData.data.telefono1.length >= 9) {
				newPhoneList.push(customerData.data.telefono1);
			}
			if (customerData.data.telefono2 && customerData.data.telefono2 != '' && customerData.phoneNumberStatus.telefono2 && customerData.phoneNumberStatus.telefono2.callable && customerData.data.telefono2.length >= 9) {
				newPhoneList.push(customerData.data.telefono2);
			}
			if (customerData.data.telefono3 && customerData.data.telefono3 != '' && customerData.phoneNumberStatus.telefono3 && customerData.phoneNumberStatus.telefono3.callable && customerData.data.telefono3.length >= 9) {
				newPhoneList.push(customerData.data.telefono3);
			}
			if (customerData.data.telefono4 && customerData.data.telefono4 != '' && customerData.phoneNumberStatus.telefono4 && customerData.phoneNumberStatus.telefono4.callable && customerData.data.telefono4.length >= 9) {
				newPhoneList.push(customerData.data.telefono4);
			}
			if (customerData.data.telefono5 && customerData.data.telefono5 != '' && customerData.phoneNumberStatus.telefono5 && customerData.phoneNumberStatus.telefono5.callable && customerData.data.telefono5.length >= 9) {
				newPhoneList.push(customerData.data.telefono5);
			}
			if (customerData.data.telefono6 && customerData.data.telefono6 != '' && customerData.phoneNumberStatus.telefono6 && customerData.phoneNumberStatus.telefono6.callable && customerData.data.telefono6.length >= 9) {
				newPhoneList.push(customerData.data.telefono6);
			}
		}
		this.conversations[indexConversation].phoneList = newPhoneList;
	}

	async getInfoRecall(indexConversation, queueId, idGestion) {
		await this.lambda_services.getRecall(idGestion)
			.then((result: any) => {
				if (result && result.con_id && result.con_genesys_list_id) {
					this.getDataCustomer(result.con_genesys_list_id, result.con_id, indexConversation, queueId);
				} else {
					this.lambda_services.getOptionCampaign(queueId, null)
						.then((results: any) => {
							//console.log(results, 'results-getOptionCampaign');

							let campana = results;
							campana.url_metadata = JSON.parse(results.url_metadata);
							//console.log(campana.subcampaing);
							if (campana &&
								campana.subcampaing &&
								campana.url_metadata &&
								campana.url_transfer &&
								campana.url_metadata.campaignTransferId &&
								campana.url_metadata.queueTransferId &&
								campana.url_metadata.queueTransferId == queueId) {
								campana = campana.subcampaing;
								campana.url_metadata = JSON.parse(campana.url_metadata);
							}
							this.conversations[indexConversation].currentCampaignLambda = campana;
							this.currentCampaign = campana;
						})
						.catch(error2 => {
							console.log(error2);
						})
				}
			}).catch(error => {
				console.log(error, 'error-getInfoRecall');
			})
	}

	getDataCustomer(contactListId, id, indexConversation, queueId) {
		this.callBackList = [];
		this.genesys_services.getContact(contactListId, id)
			.then(result => {
				this.conversations[indexConversation].currentContact = result;
				this.loadPhoneList(result, indexConversation);
				this.modifyPhoneNumber(indexConversation);
				this.lambda_services.getOptionCampaign(this.conversations[0].campaignId, queueId)
					.then((results: any) => {
						//console.log(results, 'results-getOptionCampaign');

						let campana = results;
						campana.url_metadata = JSON.parse(results.url_metadata);
						//console.log(campana.subcampaing);
						if (campana &&
							campana.subcampaing &&
							campana.url_metadata &&
							campana.url_transfer &&
							campana.url_metadata.campaignTransferId &&
							campana.url_metadata.queueTransferId &&
							campana.url_metadata.queueTransferId == queueId) {
							campana = campana.subcampaing;
							campana.url_metadata = JSON.parse(campana.url_metadata);
						}
						//console.log(campana, 'campana-getOptionCampaign');


						this.conversations[indexConversation].currentCampaignLambda = campana;
						this.currentCampaign = campana;

						// this.conversations[indexConversation].currentCampaignLambda.url_metadata = JSON.parse(this.conversations[indexConversation].currentCampaignLambda.url_metadata);
						//console.log(this.conversations[indexConversation].currentCampaignLambda, 'currentCampaignLambda-getOptionCampaign');
						this.lambda_services.getCallback(this.conversations[0].currentContact.data.con_id)
							.then((results_callbacks: any) => {
								let array_callbacks = [];
								for (let index = 0; index < results_callbacks.length; index++) {
									let element = results_callbacks[index];
									try {
										element.jso_cb_metadata = JSON.parse(element.jso_cb_metadata);
										array_callbacks.push(element);
									} catch (e) {
										array_callbacks.push(element);
									}
								}
								this.callBackList = array_callbacks;
							});
					})
					.catch(error2 => {
						console.log(error2);
					})
			})
			.catch(error => {
				console.log(error);
			});
	}

	async getDataCustomerInbound(id, queueId, customerData, indexConversation) {
		this.callBackList = [];
		let data: any = {};
		console.log(customerData);
		try {
			data = JSON.parse(customerData.datos_cliente);
		} catch (e) { }
		console.log('get Data Customer Inbound')
		console.log(customerData);
		console.log(queueId)
		console.log(data)
		//Si viene el contacto completo en la lista, lo va a buscar a genesys 
		// y va a buscar ssus callbacks
		if (data.con_id && data.con_genesys_list_id) {
			let contacto = await this.genesys_services.getContact(data.con_genesys_list_id, data.con_id)
				.then(result => {
					this.conversations[indexConversation].currentContact = result;
					this.loadPhoneList(result, indexConversation);
					this.modifyPhoneNumber(indexConversation);
					this.lambda_services.getCallback(this.conversations[0].currentContact.data.con_id)
						.then((results_callbacks: any) => {
							let array_callbacks = [];
							for (let index = 0; index < results_callbacks.length; index++) {
								let element = results_callbacks[index];
								try {
									element.jso_cb_metadata = JSON.parse(element.jso_cb_metadata);
									array_callbacks.push(element);
								} catch (e) {
									array_callbacks.push(element);
								}
							}
							this.callBackList = array_callbacks;
						});
				})
				.catch(error => {
					console.log(error);
				});
		}

		let campaignId = customerData.con_genesys_campaing_id ? customerData.con_genesys_campaing_id : queueId;
		this.lambda_services.getOptionCampaign(campaignId, null)
			.then((results: any) => {

				let campana = results;
				console.log(`Aca: ${campana.url_transfer}`)
				console.log(results.url_metadata)
				campana.url_metadata = JSON.parse(results.url_metadata);
				//console.log(campana.subcampaing);
				if (campana &&
					campana.subcampaing &&
					campana.url_metadata &&
					campana.url_transfer &&
					campana.url_metadata.campaignTransferId &&
					campana.url_metadata.queueTransferId &&
					campana.url_metadata.queueTransferId == queueId) {
					campana = campana.subcampaing;
					campana.url_metadata = JSON.parse(campana.url_metadata);
				}
				this.conversations[indexConversation].currentCampaignLambda = campana;
				this.currentCampaign = campana;
				//console.log('Aca')

			})
			.catch(error2 => {
				console.log(error2);
			});
	}

	resetCallBackPreference() {
		console.log('Entra a reset')
		console.log(this.usuario.skill)
		if (this.usuario.skills && this.usuario.skills[0].id) {
			this.callBackPreference = this.usuario.skills[0].id;
		} else {
			this.callBackPreference = '';
		}
	}
}
